import React, { useState } from "react";
import qrcode from "Assets/other/verified_license_qrcode.svg";
import blueCheckIcon from "Assets/other/blueCheckIcon.svg";
import tbiLogo from "Assets/logo/tbi-logo.svg";
import { useLocation } from "react-router-dom";
import { formatDisplayDate } from "Helper";

export const DetailLicense = () => {
  const location = useLocation();
  const userLicense = location.state?.userLicense;
  const licenseActivationDate = location.state?.licenseActivationDate;
  return (
    <div className="bg-gray-100 flex items-center justify-center">
      <div className="w-full lg:w-2/3 p-10 bg-white shadow-lg rounded-xl ">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="col-span-1">
            <img src={qrcode} alt="verified-license" className="h-full" />
          </div>
          <div className="col-span-2 grid grid-cols-1 lg:grid-cols-3 items-center text-xs lg:text-sm font-normal">
            <div>Product Name</div>
            <div className="col-span-2 text-end">
              <p className="font-black">Face Recognition</p>
            </div>

            <div>Status</div>
            <div className="col-span-2 flex items-center justify-end gap-2">
              <img src={blueCheckIcon} alt="Activated" />
              <p className="font-black">Activated</p>
            </div>

            <div>Activation Date</div>
            <div className="col-span-2 text-end">
              <p className="font-black">
                {formatDisplayDate(licenseActivationDate)}
              </p>
            </div>

            <div>Expiration</div>
            <div className="col-span-2 text-end">
              <p className="font-black">Lifetime</p>
            </div>

            <div className="mt-4 lg:mt-0 col-span-3 text-xs text-justify">
              <p>
                This product has been officially activated and is now
                operational for the Badan Pemeliharaan Keamanan Negara Republik
                Indonesia (the Indonesian National Security Maintenance Agency),
                providing enhanced support for its security and safety
                maintenance operations across the nation.
              </p>
            </div>
          </div>
        </div>

        {/* keterangan tambahan */}
        <div className="mt-4 lg:mt-0 grid grid-cols-1 lg:grid-cols-3 gap-4 items-center justify-between">
          <div className="flex gap-1 text-xs">
            <p>License ID</p>
            <p className="font-bold">{userLicense}</p>
          </div>
          <div className="flex justify-center items-center mx-auto">
            <img
              src={tbiLogo}
              alt="PT Technology Biometric Indonesia"
              className="object-contain"
            />
          </div>
          <div className="text-xs text-end">
            <p>Support</p>
            <p className="text-btn-login">contact@techbiometric.id</p>
          </div>
        </div>
      </div>
    </div>
  );
};
